import { render, staticRenderFns } from "./BulkUpdateModal.vue?vue&type=template&id=50d652ea"
import script from "./BulkUpdateModal.vue?vue&type=script&lang=js"
export * from "./BulkUpdateModal.vue?vue&type=script&lang=js"
import style0 from "./BulkUpdateModal.vue?vue&type=style&index=0&id=50d652ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports